import React, { FC, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { addOutput, OutputTypes } from 'redux/reducers/output/outputSlice'
import { selectBannerData } from 'redux/reducers/dataStore/dataStore.selectors'
import { addPCWItemsToBasket } from 'redux/reducers/logicStore/logicStore'
import { useScrollToTop } from 'hooks/useScrollToTop'
import { useEFSData } from '@dectech/react-library'
import { usePageDuration } from 'hooks/usePageDuration'
import { setCondition } from 'redux/reducers/dataStore/dataStore'
import { ConditionSelectionPage } from 'Components/Shared/ConditionSelection/ConditionSelectionPage'
import dataFileState from 'assets/data/data'
import PCWPage from 'Components/Environments/PCW/PCWPage/PCWPage'

interface TableScreenProps {
  nextPath: string
}

const PCWTableScreen: FC<TableScreenProps> = ({ nextPath: nextPage }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  // const [firstRender, setFirstRender] = useState(0)

  const { debugSelectCondition } = useEFSData<{
    debugSelectCondition: boolean
  }>()
  const [showConditionSelector, setShowConditionSelector] = useState(true)

  const bannerData = useSelector(selectBannerData)
  const stopDuration = usePageDuration('productPage')

  const handleProductSelected = (id: string): void => {
    dispatch(addPCWItemsToBasket(id))
    dispatch(addOutput({ key: OutputTypes.selectedItemID, value: id }))
    stopDuration()
    history.push(nextPage)
  }

  const handleConditionSelected = useCallback(
    (condition: number) => {
      dispatch(setCondition(condition))
      setShowConditionSelector(false)
      stopDuration()
    },
    [dispatch, stopDuration]
  )
  useScrollToTop()
  // if (firstRender > 1) {
  if (debugSelectCondition && showConditionSelector) {
    // setFirstRender(firstRender + 1)
    // console.log('firstRender', firstRender)
    return (
      <ConditionSelectionPage
        dataFile={dataFileState}
        onClick={handleConditionSelected}
      />
    )
    // }
  }

  return (
    <PCWPage
      onSelect={handleProductSelected}
      logo={bannerData.logoSrc}
      text={bannerData.text}
      headerText="<strong>Good news! We've found 8 current accounts for you to take a look at.</strong></br></br> The interest rate results are based on being <strong>£1000 in credit</strong>, and overdraft rate results are based on being <strong>£500 in debit</strong>"
    />
  )
}

export default PCWTableScreen
